import { Box, Flex, Icon, Text } from "@chakra-ui/react"

interface SelectableCardProps {
    isSelected: boolean
    text: string
    description: string
    icon: any
    onClick: () => void
}

export const SelectableCard = (props: SelectableCardProps) => {
    const { isSelected, text, description, icon, onClick } = props
    return (
        <Box
            as="button"
            onClick={onClick}
            width="200px"
            height="205px"
            borderRadius="20px"
            border="2px solid"
            borderColor={isSelected ? "blue.500" : "#DEDFE2"}
            background="white"
            p={4}
            textAlign="left"
            _hover={{ boxShadow: "md" }}
            transition="border-color 0.2s"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
        >
            {/* Top Section: Icon + Radio */}
            <Flex justifyContent="space-between" alignItems="flex-start" mb="28px" width="100%">
                <Icon
                    as={icon}
                    color={isSelected ? 'blue.500' : '#3B82F6'}
                    boxSize={7}
                />
                {isSelected ? (
                    <Box
                        width="20px"
                        height="20px"
                        borderRadius="full"
                        border="2px solid"
                        borderColor="blue.500"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg="white"
                    >
                        <Box
                            width="10px"
                            height="10px"
                            borderRadius="full"
                            bg="blue.500"
                        />
                    </Box>
                ) : (
                    <Box
                        width="20px"
                        height="20px"
                        borderRadius="full"
                        border="2px solid"
                        borderColor="#C4C7D1"
                        bg="transparent"
                    />
                )}
            </Flex>

            {/* Text Content */}
            <Flex direction="column">
                <Text fontSize="sm" fontWeight="semibold" mb="4px" color="#2D2F39">
                    {text}
                </Text>
                <Text fontSize="xs" color="#7C8493" lineHeight="short">
                    {description}
                </Text>
            </Flex>
        </Box>
    )
}